import skeleton_1_1 from "./skeleton_1_1.png";
import skeleton_2_35_1 from "./skeleton_2_35_1.png";
import skeleton_3_4 from "./skeleton_3_4.png";
import skeleton_4_3 from "./skeleton_4_3.png";
import skeleton_4_5 from "./skeleton_4_5.png";
import skeleton_9_16 from "./skeleton_9_16.png";
import skeleton_16_9 from "./skeleton_16_9.png";

type TSkeleton = {
  [index: string]: string;
};

const skeleton: TSkeleton = {
  "1_1": skeleton_1_1,
  "2_35_1": skeleton_2_35_1,
  "3_4": skeleton_3_4,
  "4_3": skeleton_4_3,
  "4_5": skeleton_4_5,
  "9_16": skeleton_9_16,
  "16_9": skeleton_16_9,
};

export default skeleton;
